<template src="./VendaRapidaNFCe.html"></template>
<style scoped src="./VendaRapidaNFCe.css"></style>

<script>
import Filter from "@/components/VendaRapidaNFCe/Filter/Filter";

import store from "@/store";

export default {
  components: {
    "app-component-venda-rapida-nfce-filter": Filter
  },
  methods: {
    onResize() {
      store.dispatch("setWindowWidth", window.innerWidth);
      store.dispatch("setWindowHeight", window.innerHeight);
    }
  },
  computed: {
    snackBar() {
      return store.state.vendaRapidaNFCe.snackBar;
    }
  }
};
</script>